module.exports = __webpack_public_path__ + "static/media/misc-benefit.8b27c3d9.png";